import { EntityType } from "@mapmycustomers/shared/enum";
import { Company } from "@mapmycustomers/shared/types/entity";
import { RouteCompanyStop } from "@mapmycustomers/shared/types/entity/Route";

import toRouteEntityAddress from "./toRouteEntityAddress";

/**
 * Builds a draft (unsaved) RouteCompanyStop from a Company entity. The returned
 * stop carries no `id` — draft stops in the editor are assigned negative/temp
 * ids by callers per the existing editor convention; this util doesn't pick the
 * id.
 *
 * The `account` projection mirrors the v2 detail/bulk-stops response shape so
 * downstream code can rely on a single stop shape from both fresh API loads
 * and editor-constructed drafts.
 */
const companyEntityToRouteStop = (
  entity: Company,
  displayOrder: number,
  allottedTime: number
): Omit<RouteCompanyStop, "createdAt" | "id" | "updatedAt"> => ({
  account: {
    ...toRouteEntityAddress(entity),
    id: entity.id,
    geoPoint: entity.geoPoint,
    name: entity.name,
  },
  accountId: entity.id,
  allottedTime,
  checkedOff: false,
  displayOrder,
  entity: EntityType.COMPANY,
});

export default companyEntityToRouteStop;
